const arrayFlat = <T = any>(array: T | T[]): T[] => {
  if (!Array.isArray(array)) {
    return [array];
  }

  return array.reduce<T[]>((prev, curr) => prev.concat(arrayFlat(curr)), []);
};

export default arrayFlat;
